/* eslint-disable @typescript-eslint/no-unsafe-return */
import {
  BundleListItems,
  postTranscriptI,
  postTranscriptResponse,
  UserListItem,
  videoCutI,
} from '@/types/user-list-item';
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from 'react-query';
import Api from './api';
import ApiV2 from './api-v2';

export const LIST_USERS_CACHE_KEY = 'list-users';
export const LIST_BUNDLE_ITEMS_CACHE_KEY = 'list-bundle-items';

export function useGetUserList(searchValue: string): UseQueryResult<UserListItem[]> {
  return useQuery([LIST_USERS_CACHE_KEY, searchValue], async () => {
    return await Api.get(`/users/${searchValue ? searchValue : ''}`);
  });
}

export function useGetBundleItems(): UseQueryResult<BundleListItems[]> {
  return useQuery(LIST_BUNDLE_ITEMS_CACHE_KEY, async () => {
    return await Api.get('/bundleItems');
  });
}

export function useVideCut(): UseMutationResult<void, unknown, videoCutI> {
  return useMutation(
    async (payload: videoCutI) => {
      // Use eos-app (ApiV2) instead of public-web-api for video cutting
      // This allows us to use the v2 brand kit system
      console.log('[useVideCut] Calling eos-app /api/video/cut', payload);
      return ApiV2.put<void>(`/api/video/cut`, payload);
    },
    {
      onSuccess: () => console.log('[useVideCut] Video cut job started successfully'),
      onError: (error) => console.error('[useVideCut] Video cut failed', error),
    },
  );
}

export function usePostTranscript(payload: postTranscriptI): UseQueryResult<any> {
  return useQuery(
    ['postTranscript', payload], // Use a unique query key
    async () => {
      if (!payload.bucketName || !payload.videoKey) return;
      const transcriptData = (await Api.post<unknown>(
        `${process.env.REACT_APP_WORKER_URL as string}/api/transcript/post`,
        payload as unknown as void,
      )) as postTranscriptResponse;
      const transcriptJsonPath = transcriptData.s3Url;
      const transcriptJson = await fetch(`${transcriptJsonPath}?timestamp=${Date.now()}`);
      const response = await transcriptJson.json();
      return response;
    },
    {
      onSuccess: () => console.log('video transcript'),
    },
  );
}
